import { render, staticRenderFns } from "./ProjectTypeSetting.vue?vue&type=template&id=f25d7124&scoped=true&"
import script from "./ProjectTypeSetting.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTypeSetting.vue?vue&type=style&index=0&id=f25d7124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25d7124",
  null
  
)

export default component.exports